import { render, staticRenderFns } from "./addChain.vue?vue&type=template&id=1ee4afb2"
import script from "./addChain.vue?vue&type=script&lang=js"
export * from "./addChain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports